module.exports = __webpack_public_path__ + "static/media/royal-suite-img4.4a79ff5c.jpg";